import { MobilePopupBottom } from '@lt/components';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { useTranslation } from '@lt/localization';
import MobileHotelFilterPopup from './components/MobileHotelFilterPopup';
import FilterInput from './components/FilterInput';
import type { PropsFromRedux } from '.';

const MobileHotelFilter = (props: PropsFromRedux) => {
  const { isFilterOpened, setFilterOpened } = props;
  const { t } = useTranslation();
  const title = t('filters.mobileHotelName.mainTitle');
  const placeholderText = t('filters.mobileHotelName.placeholder');
  const inputRef = useRef<HTMLInputElement>(null);
  return (
    <StyledFilterContainer>
      <StyledFilterTitle>{title}</StyledFilterTitle>
      <StyledFilterInputContainer>
        <FilterInput
          inputRef={inputRef}
          onClick={() => {
            setFilterOpened(true);
            if (inputRef.current) inputRef.current.blur();
          }}
          placeholderText={placeholderText}
        />
      </StyledFilterInputContainer>

      {isFilterOpened && <BackgroundLayer />}

      <StyledMobilePopupBottom visible={isFilterOpened}>
        <MobileHotelFilterPopup setIsFilterOpened={setFilterOpened} />
      </StyledMobilePopupBottom>
    </StyledFilterContainer>
  );
};

const StyledFilterContainer = styled.div`
  position: relative;
`;

const StyledMobilePopupBottom = styled(MobilePopupBottom)`
  overflow: scroll;
  z-index: 3;
  height: calc(100dvh - 16px);
  border-radius: 8px 8px 0 0;
  padding: 0;
`;

const StyledFilterTitle = styled.div`
  width: 320px;
  height: 34px;
  padding: 0px 41px 8px 8px;
  font-size: 22px;
  font-weight: 700;
`;

const StyledFilterInputContainer = styled.div`
  padding: 0 8px 16px 8px;
`;

const BackgroundLayer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background: black;
  width: 100vw;
  height: 100vh;
`;

export default MobileHotelFilter;
